import * as React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { RootState } from '../../../Store'
import { AlunoActions } from '../../../Store/Aluno'

export const useAluno = () => {
  const dispatch = useDispatch()
  const relatorioParcial = useSelector((state: RootState) => state.Aluno.relatorioParcial)
  const relatorioFinal = useSelector((state: RootState) => state.Aluno.relatorioFinal)
  const avaliacoesRelatorioFinal = useSelector((state: RootState) => state.Aluno.avaliacaoRelatorioFinal)
  const projeto = useSelector((state: RootState) => state.Aluno.projeto)
  const parametroProjeto = useSelector((state: RootState) => state.Aluno.parametroProjeto)
  const temaProjeto = useSelector((state: RootState) => state.Aluno.temaProjeto)
  const avaliacoesOficinasDebate = useSelector((state: RootState) => state.Aluno.avaliacaoOficinaDebate)
  const avaliacoesEncontrosJuridicos = useSelector((state: RootState) => state.Aluno.avaliacaoEncontroJuridico)
  const evento = useSelector((state: RootState) => state.Aluno.evento)
  const projetoApiState = useSelector((state: RootState) => state.Aluno.apiStates.projetoAction)
  const eventoApiState = useSelector((state: RootState) => state.Aluno.apiStates.eventoAction)
  const relatorioParcialApiState = useSelector((state: RootState) => state.Aluno.apiStates.relatorioParcialAction)
  const relatorioFinalApiState = useSelector((state: RootState) => state.Aluno.apiStates.relatorioFinalAction)
  const avaliacoesOficinasDebateApiState = useSelector((state: RootState) => state.Aluno.apiStates.oficinasDebateAction)
  const avaliacoesEncontrosJuridicosApiState = useSelector((state: RootState) => state.Aluno.apiStates.encontrosJuridicosAction)
  const avaliacoesRelatorioFinalApiState = useSelector((state: RootState) => state.Aluno.apiStates.avaliacoesRelatorioFinalAction)
  const enviarProjetoApiState = useSelector((state: RootState) => state.Aluno.apiStates.enviarProjetoAction)

  React.useEffect(() => {
    dispatch(AlunoActions.eventoAction())
    dispatch(AlunoActions.projetoAction())
    dispatch(AlunoActions.relatorioParcialAction())
    dispatch(AlunoActions.relatorioFinalAction())
    dispatch(AlunoActions.oficinasDebateAction())
    dispatch(AlunoActions.encontrosJuridicosAction())
    dispatch(AlunoActions.avaliacoesRelatorioFinalAction())
    dispatch(AlunoActions.temaProjetoAction())
    dispatch(AlunoActions.parametroProjetoAction())
  }, [dispatch])

  const updateProjeto = () => {
    dispatch(AlunoActions.projetoAction())
  }

  const updateRelatorioParcial = () => {
    dispatch(AlunoActions.relatorioParcialAction())
  }

  const updateRelatorioFinal = () => {
    dispatch(AlunoActions.relatorioFinalAction())
  }

  const updateAvaliacoesRelatorioFinal = () => {
    dispatch(AlunoActions.avaliacoesRelatorioFinalAction())
  }

  const enviarProjeto = (projeto: any, matriculaAluno2: string | null | undefined) => {
    dispatch(AlunoActions.enviarProjetoAction(projeto, matriculaAluno2))
  }

  return {
    enviarProjeto,
    updateProjeto,
    updateRelatorioFinal,
    updateRelatorioParcial,
    updateAvaliacoesRelatorioFinal,
    enviarProjetoApiState,
    evento,
    projeto,
    parametroProjeto,
    temaProjeto,
    relatorioParcial,
    relatorioFinal,
    avaliacoesOficinasDebate,
    avaliacoesEncontrosJuridicos,
    avaliacoesRelatorioFinal,
    relatorioFinalApiState,
    relatorioParcialApiState,
    avaliacoesRelatorioFinalApiState,
    avaliacoesOficinasDebateApiState,
    avaliacoesEncontrosJuridicosApiState,
    projetoApiState,
    eventoApiState,
  }
}
